<!-- 主动退货入库 -->
<template>
    <div class="container">
        <div class="header">
            <img class="width_24 mr-12" src="../../assets/information.png">
            <div>
                <div>直接录入的产品码（录入的大（小）箱码不影响）如果已经装过箱，执行退货后，将解除装箱绑定。</div>
                <div>(系统将视为是将箱内的产品分拆出来单独退货，省去了执行拆箱操作的步)</div>
            </div>
        </div>
        <div class="content">
            <Form :model="formData" label-position="right" :label-width="130">
                <FormItem label="发货方式：">
                    <RadioGroup v-model="formData.shipper_type" type="button">
                        <Radio label="4">退给代理商</Radio>
                        <Radio class="mr-24 ml-24" label="5">退给门店</Radio>
                        <Radio label="6">直接退回总部</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem v-if="formData.shipper_type == '4'" label="选择代理商：">
                    <Select class="w400" v-model="formData.agent_id" clearable filterable placeholder="模糊搜索代理商名称">
                        <Option v-for="item in agentList" :value="item.id" :key="item.id">{{ item.agent_name }}</Option>
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                        <div slot="content">
                            <p class="ml-12">留空则直接退回公司（不分配仓库）</p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem v-if="formData.shipper_type == '5'" label="选择门店：">
                    <Select class="w400" v-model="formData.store_id" clearable filterable placeholder="模糊搜索门店名称">
                        <Option v-for="item in storeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                        <div slot="content">
                            <p class="ml-12">留空则直接退回公司（不分配仓库）</p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem v-if="formData.shipper_type == '6'" label="选择仓库：">
                    <Select class="w400" v-model="formData.warehouse_id" clearable filterable placeholder="模糊搜索仓库">
                        <Option v-for="item in warehouseList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                        <div slot="content">
                            <p class="ml-12">未启用仓库或还没有仓库请留空。</p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem label="溯源码/外箱码：">
                    <Input class="w400" type="textarea" v-model="code" :autosize="{minRows: 6}" 
                        placeholder="一行一个，支持手工录入和扫码枪扫码录入，可以同时录入产品码，小箱码，大箱码，系统会智能分析查询匹配，自动批量智能处理" @input="handleInputChange"></Input>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                        <div slot="content">
                            <p class="ml-12">支持产品码，小箱码，大箱码混合录入。 系统会智能匹配，自动批量处理。</p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem label="选择物流公司：">
                    <Select class="w400" v-model="formData.logistics_company_id" clearable filterable placeholder="选择或搜索快递或物流公司" :label-in-value="true" @on-change="changeLogistics">
                        <Option v-for="item in logisticsList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                        <div slot="content">
                            <p class="ml-12">如果没有请留空。</p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem label="物流单号：">
                    <Input class="w400" type="text" v-model="formData.logistics_number" placeholder="请输入物流单号"></Input>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                        <div slot="content">
                            <p class="ml-12">如果没有请留空。</p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem label="备注说明：">
                    <Input class="w400" type="textarea" v-model="formData.reason" :autosize="{minRows: 6}" placeholder="填写相关备注信息，会出现在发货记录和物流记录中"></Input>
                </FormItem>
                <FormItem label="退货时间：">
                    <DatePicker class="w400" :value="formData.logistics_time" type="date" @on-change="changeLogisticsTime" placeholder="请选择发货时间"></DatePicker>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                        <div slot="content">
                            <p class="ml-12">选择退货时间，不选择则默认当前时间。</p>
                        </div>
                    </Tooltip>
                </FormItem>
                <div class="footer">
                    <Button class="theme-bg" type="warning" @click="submitForm">确定</Button>
                </div>
            </Form>
        </div>
    </div>
</template>

<script>
import { 
    incoming_coming,
} from '@/api/index';
import { 
    agent_select, 
    store_select, 
    warehouse_select, 
    incoming_select,
} from '@/api/select';
export default {
    data() {
        return {
            code: "",
            formData: { 
                shipper_type: "4",
                store_id: "",
                agent_id: "",
                logistics: "",
                logistics_number: "",
                reason: "",
                logistics_time: "",
                type: "2",
                warehouse_id: "",
                code: [],
                logistics_company_id: "",
            },
            agentList: [],
            storeList: [],
            warehouseList: [],
            logisticsList: [],
        };
    },
    mounted() {
        this.getAgentSelect();
        this.getStoreSelect();
        this.getWarehouseSelect();
        this.getIncomingSelect();
    },
    methods: {
        getAgentSelect(){
            agent_select().then( res => {
                this.agentList = res.data;
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
        getStoreSelect(){
            store_select().then( res => {
                this.storeList = res.data;
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
        getWarehouseSelect(){
            warehouse_select().then( res => {
                this.warehouseList = res.data;
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
        getIncomingSelect(){
            incoming_select().then( res => {
                this.logisticsList = res.data;
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
        changeLogisticsTime(e){
            if(e){
                this.formData.logistics_time = e;
            }else {
                this.formData.logistics_time = '';
            }
        },
        changeLogistics(e){
            if(e){
                this.formData.logistics_company_id = e.value;
                this.formData.logistics = e.label;
            }else{
                this.formData.logistics_company_id = "";
                this.formData.logistics = "";
            }
        },
        // 确定（提交表单）
        submitForm(){
            if(this.code){
                this.formData.code = this.code.split('\n').map((item, index) => {
                    if (item === '') {
                        // 如果是空字符串，表示这里有一个换行
                        return null;
                    }
                    return item;
                });
            }
            this.formData.code = this.formData.code.filter(item => item != null);
            incoming_coming(this.formData).then( res => {
                this.formData.shipper_type = "4";
                this.formData.store_id = "";
                this.formData.agent_id = "";
                this.formData.logistics = "";
                this.formData.logistics_number = "";
                this.formData.reason = "";
                this.formData.logistics_time = "";
                this.formData.type = "2";
                this.formData.warehouse_id = "";
                this.formData.code = [];
                this.formData.logistics_company_id = "";
                this.code = "";
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
        handleInputChange(e) {
            // 获取当前输入框的值
            const inputValue = e.target ? e.target.value : e;
            // 按换行符分割为数组（处理多行输入）
            const lines = inputValue.split('\n');
            // 用于存储处理后的所有码
            const allCodes = [];
            // 匹配完整URL的正则表达式（支持https/http）
            const urlPattern = /https?:\/\/[^\s?]+\?q=([\w]+)/g;
            // 处理每一行数据
            lines.forEach(line => {
                // 处理行内的所有URL
                let match;
                let lastIndex = 0;
                const results = [];
                // 1. 提取行内所有URL的q参数值
                while ((match = urlPattern.exec(line)) !== null) {
                    // 添加URL前可能存在的非URL文本
                    if (match.index > lastIndex) {
                        const textBefore = line.substring(lastIndex, match.index).trim();
                        if (textBefore) results.push(textBefore);
                    }
                    // 添加提取的q参数值
                    results.push(match[1]);
                    // 更新lastIndex
                    lastIndex = match.index + match[0].length;
                }
                // 2. 添加最后一个URL后的剩余文本
                if (lastIndex < line.length) {
                    const textAfter = line.substring(lastIndex).trim();
                    if (textAfter) results.push(textAfter);
                }
                // 3. 处理没有URL的直接输入码
                if (results.length === 0) {
                    const directCodeMatch = line.match(/^([\w\-.]+)\s*$/);
                    if (directCodeMatch) {
                        results.push(directCodeMatch[1]);
                    } else {
                        results.push(line); // 保留原始行内容
                    }
                }
                // 收集当前行的所有结果
                allCodes.push(...results);
            });
            // 更新v-model绑定的数据（去除空行）
            this.code = allCodes.filter(code => code.trim() !== '').join('\n');
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px;
    margin-bottom: 24px;
    background: rgba(255,118,29,0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
}
.width_24 {
    width: 24px;
    height: 24px;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    position: relative;
}
.footer {
    padding: 24px 0 0 0;
    margin: 24px 0 0 0;
    text-align: center;
    border-top: 1px solid #eee;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53C41A;
    border-color: #53C41A;
    box-shadow: -1px 0 0 0 #53C41A;
    border-radius: 5px;
    color: #fff;
    z-index: 1;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>